import { render, staticRenderFns } from "./shutdowns.vue?vue&type=template&id=4e98c868&"
import script from "./shutdowns.vue?vue&type=script&lang=ts&"
export * from "./shutdowns.vue?vue&type=script&lang=ts&"
import style0 from "./shutdowns.vue?vue&type=style&index=0&id=4e98c868&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports